import { Api } from 'src/common';
import { getUserId } from 'src/services/user.service';

export type AuthResponse = {
  result: {
    access_token: string;
    scope: string;
    id_token: string;
    token_type: string;
    expires_in: number;
    responseCode: number;
    responseMessage: string;
  };
  status: number;
  success: boolean;
}

enum AuthKey {
  SESSION_KEY = 'auth_token'
}

const AUTH_ENDPOINT = 'token';

const isTokenExpired = (token: string) => token && Date.now() >= (JSON.parse(atob(token.split('.')[1]))).exp * 1000;

export async function authenticate(): Promise<string> {

  const accessToken = sessionStorage.getItem(AuthKey.SESSION_KEY);

  if (accessToken && !isTokenExpired(accessToken)) {
    return accessToken
  }

  const { response, status } = await Api.post<AuthResponse>(AUTH_ENDPOINT, {
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      userId: getUserId()
    })
  })

  if (status !== 200) {
    throw new Error(response.result.responseMessage);
  }

  sessionStorage.setItem(AuthKey.SESSION_KEY, response.result.access_token)

  return response.result.access_token
}
